import React, {useEffect, useState} from "react";
import {Divider} from "@mui/material";
import {useLocation, useNavigate, useParams} from "react-router-dom";

import {NAVIGATION_BAR_HEIGHT} from "../../../../designSystem/tokens/spacing";
import {Typography} from "../../../../designSystem/components/Typography";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {Dialog} from "../../../../designSystem/components/Dialog";

import {FormPageLayout} from "../../../../components/layout/FormPageLayout";
import {NewApplicationStep3ModalContent} from "../NewApplicationStep3ModalContent";
import {NewApplicationFilesUploader} from "../NewApplicationFilesUploader";

import {useNewApplicationStep3} from "../../hooks/useNewApplicationStep3";
import {loadStoredApplication} from "../../model/loadStoredApplication";

export const NewApplicationStep3Feature = () => {
  const [files, setFiles] = useState({});
  const { category } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    dialogContent,
    submit,
    onCloseSuccessMessage,
    onClickGoHome,
    onClickGoTrack
  } = useNewApplicationStep3({ category, files })

  // check if some fields are missing, go back to last step
  useEffect(() => {
    const storedCase = loadStoredApplication();
    if (!('patientName' in storedCase) && !('patientRegion' in storedCase)){
      const lastSegment = location.pathname.split('/').filter(Boolean).pop();
      navigate(`/newApplicationStep2/${lastSegment}`);
    }
  }, [])

  return (
    <React.Fragment>
      <FormPageLayout
        height={NAVIGATION_BAR_HEIGHT.LARGE}
        body={
          <div className={"flex flex-col gap-4 p-6 "}>
            <Typography variant="title">
              請上傳檔案
            </Typography>
            <Divider />

            {/* render file selectors using a loop */}
            <NewApplicationFilesUploader
              files={files}
              onChange={values => setFiles(values)}
              category={category}
            />
          </div>
        }
        footer={
          <ActionButton
            fullWidth
            label="送出申請"
            iconName="fa-paper-plane"
            onClick={submit}
          />
        }
      />
      <Dialog isOpen={dialogContent !== ''}>
        {NewApplicationStep3ModalContent({
          handleGoHome: onClickGoHome,
          handleGoToTrack: onClickGoTrack,
          handleCloseDialog: onCloseSuccessMessage,
        })[dialogContent] || <></>}
      </Dialog>
    </React.Fragment>
  );
};
